import { useCallback } from 'react';

declare global {
  interface Window {
    Cal?: any;
  }
}

export const useCal = () => {
  // Don't load script here - let CalButton handle it
  // This hook now only provides the openCalModal function

  const openCalModal = useCallback(() => {
    // Just open in new tab for now - CalButton handles the modal
    window.open('https://cal.com/team-reflow-jvyyod/reflowai-discovery-call', '_blank');
  }, []);

  return { openCalModal };
};
